import React, { useState, useEffect, useRef } from "react";
import style from "./Performance.module.css";
import './DatePicker.css'
import performanceImage from "../../assests/hand-drawn-neuroeducation-illustration 4.png";
import ActiveCalendar from "../../assests/activeCalendar.png";
import ActiveWorkOut from "../../assests/ActiveWeightlifting-sport-exercise-gym (1).png";
import { Doughnut } from "react-chartjs-2";
import { Bar } from "react-chartjs-2";
import dayjs from "dayjs";
import { Line } from "react-chartjs-2";
import { baseurl } from "../Url";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import Loader from "../Loder/Loader";
import silverMedal from "../../assests/SilverPoint.png";
import bronzeMedal from "../../assests/BronzeMedal.png";
import goldMedal from "../../assests/GoldMedal.png";
import { useSelector } from "react-redux";
import Profile from "../../assests/Profile-PNG-File.png";
import { useNavigate } from "react-router-dom";
import PracticeInsights from "./Insights/PracticeInsights";
import AnalyticsGraph from "./AnalyticsGraph/AnalyticsGraph";
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';
import SkillMastery from "./SkillMastery/SkillMastery";
import TopicMastery from "./TopicMastery/TopicMastery";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

// Add zoom plugin configuration
const zoomOptions = {
  zoom: {
    zoom: {
      wheel: {
        enabled: false,
      },
      pinch: {
        enabled: false,
      },
      mode: "xy",
    },
    pan: {
      enabled: false,
    },
  },
};

const Performance = () => {
  const key = JSON.parse(localStorage.getItem("access-token"));
  const UserID = localStorage.getItem("USERID");
  const OrgID = localStorage.getItem("ORGID");
  const categoryId = localStorage.getItem("categoryID");

  const {
    userDetails,
    status: userStatus,
    error: userError,
  } = useSelector((state) => state.user);

  const navigate = useNavigate();

  const [mainData, setMainData] = useState({});
  const [roundGraphData, setRoundGraphData] = useState([]);
  const [learningPaceData, setLearningPaceData] = useState({});
  const [learningLevelData, setLearningLevelData] = useState({});
  const [moduleList, setModuleList] = useState([]);
  const [learningLevelModID, setLearningLevelModID] = useState("");
  const [learningPaceModID, setLearningPaceModID] = useState("");
  const [moduleProgress, setModuleProgress] = useState(0);
  const [loading, setLoading] = useState(true);
  const [todaysDailyScore, setTodaysDailyScore] = useState("");
  const [todaysWeeklyScore, setTodaysWeeklyScore] = useState("");

  const [selectedModule, setSelectedModule] = useState(0);
  const [dailyDrillData, setDailyDrillData] = useState([]);
  const [weeklyWorkoutData, setWeeklyWorkoutData] = useState([]);
  const [dateForDD, setDateForDD] = useState("week");
  const [dateForWW, setDateForWW] = useState("month");
  const [dateForLP, setDateForLP] = useState("weekly");
  const [point, setPoint] = useState("");
  const [leaderBoardData, setLeaderBoardData] = useState([]);

  const [achievementDetails, setAchievementDetails] = useState([]);
  const [selectedBadge, setSelectedBadge] = useState(null);

  const [selectedDate, setSelectedDate] = useState(null);
  const [showCalendar, setShowCalendar] = useState(null);
  const calendarRef = useRef(null);
  const performanceRef = useRef(null);
  const assessmentBoxRef = useRef(null);
  const dailyCardRef = useRef(null);
  const weeklyCardRef = useRef(null);
  const dailyLinkRef = useRef(null);
  const weeklyLinkRef = useRef(null);
  const [calendarPos, setCalendarPos] = useState({ top: 0, left: 0 });
  const [notAttendedDates, setNotAttendedDates] = useState([]);
  const [notAttendedWeeks, setNotAttendedWeeks] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [learningModules, setLearningModules] = useState([]);
  const [isNarrowScreen, setIsNarrowScreen] = useState(
    () => typeof window !== "undefined" && window.innerWidth <= 580
  );

  const now = new Date();
  const currentMonth = now.toLocaleString("default", { month: "short" });

  const handleLinkClick = (type) => (e) => {
    e.preventDefault();
    const cardEl = type === "daily" ? dailyCardRef.current : weeklyCardRef.current;
    const boxEl = assessmentBoxRef.current;
    if (cardEl && boxEl) {
      const cardRect = cardEl.getBoundingClientRect();
      const boxRect = boxEl.getBoundingClientRect();
      setCalendarPos({
        top: cardRect.bottom - boxRect.top + 10,
        left: cardRect.left - boxRect.left + cardRect.width / 2,
      });
    }
    setSelectedDate(null);
    setShowCalendar(showCalendar === type ? null : type);
  };
  const handleDateSelect = (date) => {
  setSelectedDate(date); 
};
  useEffect(() => {
    if (mainData?.Completed_Drills) {
      setNotAttendedDates(mainData.Completed_Drills.not_attended || []);
      setNotAttendedWeeks(mainData.Completed_Drills.not_attended_weeks || []);
    }
  }, [mainData]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setShowCalendar(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => setIsNarrowScreen(window.innerWidth <= 580);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // no window listeners needed for absolute within container

  const handleDDDate = (date) => {
    setDateForDD(date);
    dailyDrillGraph(date);
  };

  const handleWWDate = (date) => {
    setDateForWW(date);
    weeklyWorkoutGraph(date);
  };
  const handleLPDate = (date) => {
    setDateForLP(date);
  };

  const handleImageClick = (badgeId) => {
    setSelectedBadge(badgeId === selectedBadge ? null : badgeId);
  };

  const getColorBasedOnPercentage = (percentage) => {
    if (percentage > 75) return "#03CD09";
    if (percentage > 50) return "#FFCB34";
    if (percentage > 25) return "#FF8800";
    return "#FF2443";
  };

  const dailyLineLabels = dailyDrillData.map((item) => {
    if (dateForDD === "year") {
      return item["x-axis"].substring(5, 7);
    } else {
      return item["x-axis"].substring(8, 10);
    }
  });
  const firstDate =
    dailyDrillData.length > 0 ? dailyDrillData[0]["x-axis"] : "";
  const monthName = firstDate ? dayjs(firstDate).format("MMM") : "";
  const dailyLineScores = dailyDrillData.map((item) => item["y-axis"]);
  const ddCorrectScores = dailyDrillData.map((item) => item["correct"]);
  const ddTimeInSeconds = dailyDrillData.map((item) => item["time_sec"]);
  let xAxisTitle = "";

  if (dateForDD === "year") {
    xAxisTitle = "Month";
  } else if (dateForDD === "month") {
    xAxisTitle = `${currentMonth}`;
  } else if (dateForDD === "week") {
    xAxisTitle = `Week`;
  }

  const lineChartData = {
    labels: dailyLineLabels,
    datasets: [
      {
        label: "Today Scores",
        data: dailyLineScores,
        borderColor: "#595BDB",
        backgroundColor: "rgba(89, 91, 219, 0.2)",
        fill: true,
        tension: 0.3,
        borderWidth: 2,
        pointBackgroundColor: "#595BDB",
        pointBorderColor: "#fff",
        pointBorderWidth: 2,
        pointRadius: 5,
      },
    ],
  };

  const weeklyLineLabels = weeklyWorkoutData.map((item) => {
    if (dateForWW === "year") {
      return item["x-axis"].substring(5, 7);
    } else {
      return item["x-axis"].substring(8, 10);
    }
  });
  const firstWeeklyDate =
    weeklyWorkoutData.length > 0 ? weeklyWorkoutData[0]["x-axis"] : "";
  const weeklyMonthName = firstWeeklyDate
    ? dayjs(firstWeeklyDate).format("MMM")
    : "";
  const weeklyLineScores = weeklyWorkoutData.map((item) => item["y-axis"]);
  const wwCorrectScores = weeklyWorkoutData.map((item) => item["correct"]); // Array of correct scores
  const wwTimeInSeconds = weeklyWorkoutData.map((item) => item["time_sec"]);

  const weeklyLineChart = {
    labels: weeklyLineLabels,
    datasets: [
      {
        label: "Weekly Scores",
        data: weeklyLineScores,
        borderColor: "#29bcd6",
        backgroundColor: "#7adef0",
        fill: true,
        tension: 0.3,
        borderWidth: 2,
        pointBackgroundColor: "#29bcd6",
        pointBorderColor: "#fff",
        pointBorderWidth: 2,
        pointRadius: 5,
      },
    ],
  };

  const learningPaceLabels = learningPaceData?.data?.map((item) =>
    dateForLP === "yearly"
      ? dayjs(item.period).format("MMM")
      : dayjs(item.period).format("DD")
  );

  const firstLLDate =
    learningPaceData?.data?.length > 0
      ? learningPaceData?.data[0]["period"]
      : "";
  const lLMonthName = firstLLDate ? dayjs(firstLLDate).format("MMM") : "";

  const topicCounts = learningPaceData?.data?.map((item) => item.topic_count);

  const learningPaceChartData = {
    labels: learningPaceLabels,
    datasets: [
      {
        label:
          dateForLP === "yearly" ? "Monthly Topic Count" : "Daily Topic Count",
        data: topicCounts,
        backgroundColor: "#FF8800",
        barThickness: 20,
        borderRadius: 10,
      },
    ],
  };

  const learningPaceOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          title: function (context) {
            return ""; // Hide the title (day information)
          },
          label: function (context) {
            return `No of Topics  ${context.raw}`;
          },
        },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text:  dateForLP === "yearly"
        ? "Month"
        : dateForLP === "monthly"
        ? `${currentMonth}`
        : `Day`,
        },
        grid: {
          display: false,
        },
        beginAtZero: false,
        ticks: {
          stepSize: 1,
        },
      },
      y: {
        title: {
          display: true,
          text: "Total no.of topics",
        },
        beginAtZero: true,
        max: learningPaceData.module_topics_count,
        ticks: {
          stepSize: 1,
          callback: function (value) {
            return value;
          },
        },
        grid: {
          drawBorder: false,
          drawTicks: false,
        },
      },
    },
    ...zoomOptions,
  };

  const learningLevelGraphData = {
    labels: [...Array(learningLevelData?.module_topics_count).keys()],
    datasets: [
      {
        label: "Baseline Score",
        data: learningLevelData?.data?.map((topicArray) => {
          const baselineData = topicArray.find(
            (topic) => topic.score_level === "baseline"
          );
          return baselineData ? parseFloat(baselineData.score) : null;
        }),
        backgroundColor: "#595BDB",
        barThickness: 20,
        borderRadius: 10,
      },
      {
        label: "Current Score",
        data: learningLevelData?.data?.map((topicArray) => {
          const currentData = topicArray.find(
            (topic) => topic.score_level === "current"
          );
          return currentData ? parseFloat(currentData.score) : null;
        }),
        backgroundColor: "#FFBE00",
        barThickness: 20,
        borderRadius: 10,
      },
    ],
  };

  const learningLevelOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          title: function (context) {
            return ""; // Hide the title (day information)
          },
          label: function (context) {
            return `${context.dataset.label}: ${context.raw}%`;
          },
        },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Topics",
        },
        grid: {
          display: false,
        },
        ticks: {
          stepSize: 1,
          callback: function (value) {
            return value + 1;
          },
        },
      },
      y: {
        title: {
          display: true,
          text: "Score (%)",
        },
        beginAtZero: true,
        max: 100,
        ticks: {
          stepSize: 20,
          callback: function (value) {
            return value + "%";
          },
        },
        grid: {
          drawBorder: false,
          drawTicks: false,
        },
      },
    },
    ...zoomOptions,
  };

  async function mainAnalytics() {
    await fetch(`${baseurl}/performance/analytics/main`, {
      method: "POST",
      body: JSON.stringify({
        user_id: UserID,
        org_id: OrgID,
        category_id: categoryId,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${key}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.status === true) {
          setMainData(data.data[0]);
        } else {
          setMainData({});
        }
        setLoading(false);
      });
  }
    async function learningList() {
      await fetch(`${baseurl}/userlearning/details/v2`, {
        method: "POST",
        body: JSON.stringify({ user_id: userDetails && userDetails._id?.$oid }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userDetails && userDetails.auth_token}`,
        },
      })
    .then((res) => res.json())
    .then((data) => {
      if (data.status === true) {

        const topics = data.data[0]?.Topics || [];

        const fixedTopics = topics.map(topic => ({
          ...topic,
          module_name: topic.module_name || "General topics",
          isExpand: false,
        }));

        const uniqueModules = [
          ...new Map(fixedTopics.map(t => [t.module_id, t])).values()
        ];
        setLearningModules(uniqueModules);
        setModuleList(uniqueModules); 

        if (uniqueModules.length > 0) {
          setLearningPaceModID(uniqueModules[0].module_id);
          setLearningLevelModID(uniqueModules[0].module_id);
          setSelectedModule(0);
          topicAnalytics(uniqueModules[0].module_id);
        }

      } else {
        setLearningData({});
        setLoading(false);
      }
    });
}

  async function topicAnalytics(modID) {
    await fetch(`${baseurl}/performance/module-topic-summary`, {
      method: "POST",
      body: JSON.stringify({
        user_id: UserID,
        module_id: modID,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${key}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.status === true) {
          setRoundGraphData(data.data);
          setModuleProgress(data.module_progress);
        } else {
          setRoundGraphData([]);
          setModuleProgress(0);
        }
      });
  }
  async function learningPace(modID, date) {
    await fetch(`${baseurl}/performance/topic-count`, {
      method: "POST",
      body: JSON.stringify({
        user_id: UserID,
        module_id: modID,
        filter: date,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${key}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.status === true) {
          setLearningPaceData(data);
        } else {
          setLearningPaceData(data);
        }
      });
  }
  async function learningLevel(modID) {
    await fetch(`${baseurl}/performance/learning-level`, {
      method: "POST",
      body: JSON.stringify({
        user_id: UserID,
        module_id: modID,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${key}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.status === true) {
          setLearningLevelData(data);
        } else {
          setLearningLevelData();
        }
      });
  }

  async function dailyDrillGraph(type) {
    await fetch(`${baseurl}/analytics/scores/daily`, {
      method: "POST",
      body: JSON.stringify({
        user_id: UserID,
        filter_type: type,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${key}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.status === true) {
          setDailyDrillData(data.data);
          setTodaysDailyScore(data.todays_score);
        } else {
          setDailyDrillData([]);
        }
      });
  }
  async function weeklyWorkoutGraph(type) {
    await fetch(`${baseurl}/analytics/scores/weekly`, {
      method: "POST",
      body: JSON.stringify({
        user_id: UserID,
        filter_type: type,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${key}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.status === true) {
          setWeeklyWorkoutData(data.data);
          setTodaysWeeklyScore(data.todays_score);
        } else {
          setWeeklyWorkoutData([]);
        }
      });
  }

  async function badgeGet() {
    const body = {
      user_id: UserID,
    };

    await fetch(`${baseurl}/user_badges`, {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${key}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.status === true) {
          const topicAndModule =
            data.data?.Topic_and_module?.filter(
              (item) => item.status === true
            ) || [];
          const dailyDrill =
            data.data?.Daily_Drill?.filter((item) => item.status === true) ||
            [];
          const weeklyWorkout =
            data.data?.Weekly_Workout?.filter((item) => item.status === true) ||
            [];

          const sortedData = [
            ...topicAndModule,
            ...dailyDrill,
            ...weeklyWorkout,
          ];
          setAchievementDetails(sortedData);
        }
      });
  }
  const loggedInUserId = localStorage.getItem("USERID");

  async function getLeaderBoard() {
    await fetch(`${baseurl}/leader_board`, {
      method: "POST",
      body: JSON.stringify({
        org_id: userDetails && userDetails.org_id || OrgID,
        user_id:loggedInUserId,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDetails && userDetails.auth_token}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.status === true) {
          setLeaderBoardData(data.data);
        } else {
          setLeaderBoardData([]);
        }
      });
  }

  useEffect(() => {
    if (categoryId) {
      mainAnalytics();
      learningList(); 
      dailyDrillGraph("week");
      weeklyWorkoutGraph("month");
      badgeGet();
    }
  }, [categoryId]);
useEffect(() => {
  if (mainData?.start_date) {
    const parsedDate = dayjs(mainData.start_date).toDate();
    console.log("Parsed start date:", parsedDate);
    setStartDate(parsedDate);
  }
}, [mainData]);
  useEffect(() => {
    if (learningPaceModID) {
      learningPace(learningPaceModID, dateForLP);
    }
  }, [learningPaceModID, dateForLP]);

  useEffect(() => {
    if (learningLevelModID) {
      learningLevel(learningLevelModID);
    }
  }, [learningLevelModID]);

  useEffect(() => {
    if (userDetails && userDetails.Rewards) {
      setPoint(userDetails && userDetails.Rewards?.Badge);
    } else {
      setPoint("");
    }
    getLeaderBoard();
  }, [userDetails]);

  return (
    <div className={style.container}>
      {loading ? <Loader /> : ""}
      <div className={style.performance} ref={performanceRef}>
        <div className={style.welcomeSection}>
          <div className={style.welcomeSectionLeft}>
            <p>My Dashboard</p>
            <span>
              See how far you've come and where you need more practice
            </span>
          </div>
          <div className={style.welcomeSectionRight}>
            <div className={style.welcomeImageContainer}>
              <div className={style.welcomeImage}>
                <img src={performanceImage} alt="welcome" />
              </div>
            </div>
          </div>
        </div>
        <h5 className={style.insightsHeading}>Daily Drill and Weekly Workout Insights</h5>

        <div className={style.assessmentSectionBox} ref={assessmentBoxRef}>
          {/* {point !== "" ? (
            <div className={style.userPointCard}>
              <img
                src={
                  point === "Silver"
                    ? silverMedal
                    : point === "Bronze"
                      ? bronzeMedal
                      : point === "Gold"
                        ? goldMedal
                        : ""
                }
                alt="avatar"
              />
            </div>
          ) : null} */}
          <div className={style.dailyDrillCard} ref={dailyCardRef}>
            <div className={style.assessmentCard}>
              {/* Title centered at top */}
              <h4 className={style.cardMainTitle}>Daily drills</h4>
              
              {/* Stats Row */}
              <div className={style.assessmentCardTopRow}>
                <div className={style.statsColumn}>
                  <div className={style.largeNumberLabel}>
                    <span className={style.orangeNumber}>
                      {mainData.Completed_Drills?.completed_daily || 0}
                    </span>
                    <span className={style.dividerSlash}>/</span>
                    <span className={style.possibleNumber}>
                      {mainData.Completed_Drills?.possible_daily || 0}
                    </span>
                  </div>
                  <span className={style.completedAvailableLabel}>(Completed / Total)</span>
                </div>
                <div className={style.iconColumn}>
                  <img src={ActiveCalendar} alt="dailyDrill" className={style.cardIllustrationIcon} />
                </div>
              </div>

              {/* Progress and Link */}
              <div className={style.assessmentCardBottomRow}>
                <p className={style.percentCompletedLabel}>% Completed</p>
                <div className={style.progressFlexContainer}>
                  <progress
                    className={style.orangeProgressBar}
                    value={mainData.Completed_Drills?.daily_percent || 0}
                    max="100"
                  ></progress>
                  <span className={style.percentText}>
                    {mainData.Completed_Drills?.daily_percent || 0}%
                  </span>
                </div>
                
                {mainData.Completed_Drills?.start_date != null && (
                  <div className={style.missedLinkWrapper}>
                    <a href="#" ref={dailyLinkRef} onClick={handleLinkClick("daily")} className={style.missedLink}>
                      What did you miss?
                    </a>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className={style.weeklyWorkOutCard} ref={weeklyCardRef}>
            <div className={style.assessmentCard}>
              {/* Title centered at top */}
              <h4 className={style.cardMainTitle}>Weekly workouts</h4>
              
              {/* Stats Row */}
              <div className={style.assessmentCardTopRow}>
                <div className={style.statsColumn}>
                  <div className={style.largeNumberLabel}>
                    <span className={style.tealNumber}>
                      {mainData.Completed_Drills?.completed_weekly || 0}
                    </span>
                    <span className={style.dividerSlash}>/</span>
                    <span className={style.possibleNumber}>
                      {mainData.Completed_Drills?.possible_weekly || 0}
                    </span>
                  </div>
                  <span className={style.completedAvailableLabel}>(Completed / Total)</span>
                </div>
                <div className={style.iconColumn}>
                  <img src={ActiveWorkOut} alt="weeklyWorkout" className={style.cardIllustrationIcon} />
                </div>
              </div>

              {/* Progress and Link */}
              <div className={style.assessmentCardBottomRow}>
                <p className={style.percentCompletedLabel}>% Completed</p>
                <div className={style.progressFlexContainer}>
                  <progress
                    className={style.tealProgressBar}
                    value={mainData.Completed_Drills?.weekly_percent || 0}
                    max="100"
                  ></progress>
                  <span className={style.percentText}>
                    {mainData.Completed_Drills?.weekly_percent || 0}%
                  </span>
                </div>
                
                {mainData.Completed_Drills?.start_date != null && (
                  <div className={style.missedLinkWrapper}>
                    <a href="#" ref={weeklyLinkRef} onClick={handleLinkClick("weekly")} className={style.missedLink}>
                      What did you miss?
                    </a>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Leaderboard Card inline */}
          <div className={style.graphSectionRight}>
            <div className={style.leaderBoardHeader}>
              <p>Leaderboard</p>
            </div>
            <div className={style.leaderBoardBody}>
              {leaderBoardData.map((leader, index) => (
                <div
                  key={leader.name}
                  style={{
                    background:
                      leader.badge === "Silver"
                        ? "linear-gradient(90deg, #B5B5B5 0%, rgba(150, 150, 150, 0.52) 52.76%, #7B7B7B 100%)"
                        : leader.badge === "Bronze"
                          ? "linear-gradient(90deg, #AD673F 0%, rgba(205, 124, 78, 0.78) 54.72%, #773F24 109.82%)"
                          : leader.badge === "Gold"
                            ? "linear-gradient(87.74deg, rgba(255, 190, 0, 0.7) 25.33%, rgba(255, 226, 140, 0.7) 54.66%, rgba(204, 152, 0, 0.7) 97.1%)"
                            : "",
                  }}
                  className={`${style.leaderBoardCard} ${leader.user_id === loggedInUserId ? style.highlightCard : ""}`}
                >
                  <div className={style.leaderCardLeft}>
                    <div className={style.leaderCardLeftTop}>
                      <div className={style.leaderRank}>
                        {leader.rank? <p>{leader.rank}</p> :""}
                      </div>
                      <div className={style.leaderName}>
                        <p>{leader.user_name}</p>
                      </div>
                      <div className={style.leaderPoint}>
                        <p>{leader.total_coins}</p>
                      </div>
                    </div>
                  </div>
                  <div className={style.leaderCardRight}>
                    <img src={leader.profile || Profile} alt="Leader" />
                  </div>
                </div>
              ))}
            </div>
          </div>
          {showCalendar === "daily" && (
          <div
            ref={calendarRef}
            className={`${style.calendarWrapperDaily} ${isNarrowScreen ? style.calendarMobile : ""}`}
            style={
              isNarrowScreen
                ? undefined
                : {
                    position: "absolute",
                    top: calendarPos.top,
                    left: calendarPos.left,
                    transform: "translate(-50%, 10px)",
                  }
            }>
            <p> Oops! You have missed{" "}<strong>{mainData.Completed_Drills?.total_missed_daily ?? 0}</strong>{" "}Daily Drills</p>
            <DatePicker
              inline
              minDate={dayjs(mainData.Completed_Drills?.start_date).toDate()}
              maxDate={new Date()} 
              dayClassName={(date) => {
                const formattedDate = dayjs(date).format("YYYY-MM-DD");
                return notAttendedDates.includes(formattedDate)
                  ? "not-attended-day"
                  : undefined;
              }}
              calendarClassName="datepicker-daily"
            />
          </div>
          )}

          {showCalendar === "weekly" && (
          <div
            ref={calendarRef}
            className={`${style.calendarWrapperWeekly} ${isNarrowScreen ? style.calendarMobile : ""}`}
            style={
              isNarrowScreen
                ? undefined
                : {
                    position: "absolute",
                    top: calendarPos.top,
                    left: calendarPos.left,
                    transform: "translate(-50%, 10px)",
                  }
            }>
            <p>
              Oops! You have missed{" "}
              <strong >
                {mainData.Completed_Drills?.completed_weekly > 0
                 ? Math.max(
                     mainData.Completed_Drills.possible_weekly - mainData.Completed_Drills.completed_weekly,
                     0
                   )
                 : mainData.Completed_Drills?.completed_weekly || 0}
              </strong>{" "}
              Weekly Drills
            </p>

            <DatePicker
              inline
              minDate={dayjs(mainData.Completed_Drills?.start_date).toDate()}
              maxDate={new Date()} 
              dayClassName={(date) => {
                const formattedDate = dayjs(date).format("YYYY-MM-DD");
                return notAttendedWeeks.some((week) => week.includes(formattedDate))
                  ? "not-attended-week"
                  : undefined;
              }}
              calendarClassName="datepicker-weekly"
            />
          </div>
          )}
        </div>

          <div className={style.assessmentSection}>
          <div className={style.assessmentSectionLeft}>
            <div className={style.learningHeader}>
              <p>Daily drill</p>
            </div>
            <div className={style.drillHeader}>
              <div className={style.learningSubHeaderLeft}>
                <div
                  className={`${style.subHeaderCard} ${dateForDD === "week" ? style.selectedSubHeaderCard : ""
                    }`}
                  onClick={() => {setDailyDrillData([]);handleDDDate("week")}}
                >
                  <p>Week</p>
                </div>
                <div
                  className={`${style.subHeaderCard} ${dateForDD === "month" ? style.selectedSubHeaderCard : ""
                    }`}
                  onClick={() => {setDailyDrillData([]);handleDDDate("month")}}
                >
                  <p>Month</p>
                </div>
                <div
                  className={`${style.subHeaderCard} ${dateForDD === "year" ? style.selectedSubHeaderCard : ""
                    }`}
                  onClick={() => {setDailyDrillData([]);handleDDDate("year")}}
                >
                  <p>Year</p>
                </div>
              </div>
              <div className={style.learningSubHeaderRight}>
                <div className={style.assessmentScore}>
                  <p>
                    Today's <br />
                    Score
                  </p>
                  <h4>{todaysDailyScore}</h4>
                </div>
              </div>
            </div>
            <div className={style.lineGraph}>
              <Line
                data={lineChartData}
                options={{
                  responsive: true,
                  plugins: {
                    legend: {
                      display: false,
                    },
                    tooltip: {
                      callbacks: {
                        title: function (context) {
                          return ""; // Hide the title (day information)
                        },
                        label: function (context) {
                          const index = context.dataIndex;
                          const score = ddCorrectScores[index];
                          const timeSec = ddTimeInSeconds[index];
                          const timeMin = Math.floor(timeSec / 60);

                          const timeDisplay =
                            timeMin > 0 ? `${timeMin} mins` : `less than 1 min`;

                          return `You scored ${score} in ${timeDisplay}`;
                        },
                      },
                    },
                  },
                  scales: {
                    x: {
                      type: "category",
                      title: {
                        display: true,
                        text: xAxisTitle,
                      },
                      grid: {
                        display: false,
                      },
                      beginAtZero: false,
                      offset: true,
                      ticks: {
                        callback: function (value, index) {
                          return dailyLineLabels[index];
                        },
                      },
                    },
                    y: {
                      title: {
                        display: true,
                        text: "Score (%)",
                      },
                      grid: {
                        display: false,
                      },
                      beginAtZero: true,
                      min: 0,
                      max: 100,
                      ticks: {
                        stepSize: 20,
                      },
                    },
                  },
                  ...zoomOptions,
                }}
              />
            </div>
          </div>
          <div className={style.assessmentSectionRight}>
            <div className={style.learningHeader}>
              <p>Weekly workout</p>
            </div>
            <div className={style.drillHeader}>
              <div className={style.learningSubHeaderLeft}>
                <div
                  className={`${style.subHeaderCard} ${dateForWW === "month" ? style.selectedSubHeaderCard : ""
                    }`}
                  onClick={() => {setWeeklyWorkoutData([]);handleWWDate("month")}}
                >
                  <p>Month</p>
                </div>
                <div
                  className={`${style.subHeaderCard} ${dateForWW === "year" ? style.selectedSubHeaderCard : ""
                    }`}
                  onClick={() => {setWeeklyWorkoutData([]);handleWWDate("year")}}
                >
                  <p>Year</p>
                </div>
              </div>
              <div className={style.learningSubHeaderRight}>
                <div
                  className={style.assessmentScore}
                  style={{border: "1px solid #00DFC7"}}
                >
                  <p>
                    Week's <br />
                    Score
                  </p>
                  <h4 style={{color:"#00DFC7"}}>{todaysWeeklyScore}</h4>
                </div>
              </div>
            </div>

            <div className={style.lineGraph}>
              <Line
                data={weeklyLineChart}
                options={{
                  responsive: true,
                  plugins: {
                    legend: {
                      display: false,
                    },
                    tooltip: {
                      callbacks: {
                        title: function (context) {
                          return ""; // Hide the title (day information)
                        },
                        label: function (context) {
                          const index = context.dataIndex;
                          const score = wwCorrectScores[index];
                          const timeSec = wwTimeInSeconds[index];
                          const timeMin = Math.floor(timeSec / 60);
                          const timeDisplay =
                            timeMin > 0 ? `${timeMin} mins` : `< 1 min`;

                          return `You scored ${score} in ${timeDisplay}`;
                        },
                      },
                    },
                  },
                  scales: {
                    x: {
                      title: {
                        display: true,
                        text: dateForWW === "year" ? "Month" : `${currentMonth}`,
                      },
                      grid: {
                        display: false,
                      },
                      offset: true,
                    },
                    y: {
                      title: {
                        display: true,
                        text: "Score (%)",
                      },
                      grid: {
                        display: false,
                      },
                      beginAtZero: true,
                      min: 0,
                      max: 100,
                      ticks: {
                        stepSize: 20,
                      },
                    },
                  },
                  ...zoomOptions,
                }}
              />
            </div>
          </div>
        </div>
        <PracticeInsights />


        <div className={style.learningSection}>
          <div className={style.learningSectionLeft}>
            <div className={style.learningHeader}>
              <p>Learning Level</p>
            </div>
            <div className={style.learningSubHeader}>
              <div className={style.levelHeader}>
                <div className={style.levelHeaderCard}>
                  <span></span>
                  <h4>Current score</h4>
                  <p>(The mark from your last attempt)</p>
                </div>
                <div className={style.levelHeaderCard}>
                  <span></span>
                  <h4>Baseline score</h4>
                  <p>(The mark from your first attempt)</p>
                </div>
              </div>
              <div className={style.learningSubHeaderRight}>
                <div className={style.moduleSelectWrap}>
                  <select
                    value={learningLevelModID}
                    onChange={(e) => setLearningLevelModID(e.target.value)}
                  >
                    {moduleList &&
                      moduleList.length > 0 &&
                      moduleList.map((mod, index) => (
                        <option key={mod.module_id} value={mod.module_id}>
                          {`Module ${index + 1}`}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
            </div>
             <div className={style.barGraph}>
              <Bar
                data={learningLevelGraphData}
                options={learningLevelOptions}
              />
            </div>           
          </div>
          <div className={style.learningSectionRight}>
            <div className={style.learningHeader}>
              <p>Learning Pace</p>
            </div>
            <div className={style.learningSubHeader}>
              <div className={style.learningSubHeaderLeft}>
                <div
                  className={`${style.subHeaderCard} ${dateForLP === "weekly" ? style.selectedSubHeaderCard : ""
                    }`}
                  onClick={() => handleLPDate("weekly")}
                >
                  <p>Week</p>
                </div>
                <div
                  className={`${style.subHeaderCard} ${dateForLP === "monthly" ? style.selectedSubHeaderCard : ""
                    }`}
                  onClick={() => handleLPDate("monthly")}
                >
                  <p>Month</p>
                </div>
                <div
                  className={`${style.subHeaderCard} ${dateForLP === "yearly" ? style.selectedSubHeaderCard : ""
                    }`}
                  onClick={() => handleLPDate("yearly")}
                >
                  <p>Year</p>
                </div>
              </div>
              <div className={style.learningSubHeaderRight}>
                <div className={style.moduleSelectWrap}>
                  <select
                    value={learningPaceModID}
                    onChange={(e) => setLearningPaceModID(e.target.value)}
                  >
                    {moduleList &&
                      moduleList.length > 0 &&
                      moduleList.map((mod, index) => (
                        <option key={mod.module_id} value={mod.module_id}>
                          {`Module ${index + 1}`}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
            </div>           
            <div className={style.barGraph}>
              <Bar data={learningPaceChartData} options={learningPaceOptions} />
            </div>
          </div>
        </div>
        {/* <div className={style.moduleSection}>
          <div className={style.moduleHeder}>
            <p>Modules</p>
          </div>
          <div className={style.numberBarSection}>
            <div className={style.numberBar}>
              {learningModules.length > 0 &&
                learningModules.map((module, index) => (
                  <div
                    key={module.module_id}
                    className={
                      selectedModule === index ? style.numberContainer : ""
                    }
                  >
                    <div
                      key={module.module_id}
                      className={
                        selectedModule === index
                          ? style.selectedNumber
                          : style.number
                      }
                      onClick={() => {
                        setSelectedModule(index);
                        topicAnalytics(module.module_id);
                      }}
                    >
                      {index + 1}
                    </div>
                  </div>
                ))}
            </div>
          </div>
          <div className={style.moduleSubHeder}>
            {mainData.Modules?.length > 0 &&
              mainData.Modules[selectedModule] ? (
              <p>
                Module progress:{" "}
                <span>{mainData.Modules[selectedModule]?.module_name}</span>
              </p>
            ) : (
              <p>
                Module progress: <span>No Module Selected</span>
              </p>
            )}
          </div>
          <div className={style.progressBarSection}>
            <div
              className={style.progressBar}
              style={{
                backgroundColor: "#8E88903D",
                borderRadius: "2rem",
              }}
            >
              <div
                style={{
                  width: `${moduleProgress}%`,
                  backgroundColor: "#595BDB",
                  height: "12px",
                  transition: "width 0.5s ease-in-out",
                  borderRadius: "1rem",
                }}
              ></div>
            </div>
            <div className={style.progressBarCount}>
              <p>{Math.round(moduleProgress)}%</p>
            </div>
          </div>
          <div className={style.roundGraphSection}>
            {roundGraphData.length > 0 &&
              roundGraphData.map((data, i) => {
                const color = getColorBasedOnPercentage(
                  data.percentage_correct
                );
                const chartData = {
                  labels: ["Achieved", "Remaining"],
                  datasets: [
                    {
                      data: [
                        data.percentage_correct,
                        100 - data.percentage_correct,
                      ],
                      backgroundColor: [color, "#EAEAEA"],
                      borderWidth: 0,
                    },
                  ],
                };

                const options = {
                  cutout: "80%",
                  plugins: {
                    legend: {
                      display: false,
                    },
                    tooltip: {
                      enabled: false,
                    },
                  },
                  ...zoomOptions,
                };
                return (
                  <div key={i} className={style.roundGraphCard}>
                    <div className={style.roundGraphCardHeder}>
                      <p>Topic {i + 1}</p>
                    </div>
                    <div className={style.roundGraph}>
                      <Doughnut data={chartData} options={options} />
                      <div className={style.roundGraphData}>
                        <div
                          className={style.tooltip}
                          data-tooltip="Latest score"
                        >
                          <p>{data.correct_anslearningLevelGraphDatawers}</p>
                        </div>
                      </div>
                    </div>

                    <div
                      className={`${style.roundGraphCardBottom} ${style.tooltip}`}
                      data-tooltip="Average score"
                    >
                      <p>{Math.round(data.percentage_correct)}%</p>
                    </div>
                  </div>
                );
              })}
          </div>
        </div> */}




        <AnalyticsGraph learningModules={learningModules}/>
          {/* <SkillMastery/> */}
          {achievementDetails && achievementDetails.length > 0 ? (
          <>
            <div className={style.achievementHeader}>
              <p>Achievements</p>
            </div>
            <div className={style.achievementSection}>
              <div className={style.achievementGrid}>
                {achievementDetails &&
                  achievementDetails.length > 0 &&
                  achievementDetails.slice(0, 6).map((data) => (
                    <div key={data.badge_id} className={style.achievementCard}>
                      <div
                        className={`${style.achievementCardImage} ${selectedBadge === data.badge_id
                          ? style.selectedImage
                          : ""
                          }`}
                        onClick={() => handleImageClick(data.badge_id)}
                      >
                        <img src={data.active_img} alt="img" />
                        {data.count > 0 ? <p>x{data.count}</p> : null}
                      </div>
                      <div className={style.achievementCardText}>
                        <p>{data.name} </p>
                        {selectedBadge === data.badge_id && (
                          <span>{data.description}</span>
                        )}
                      </div>
                    </div>
                  ))}
              </div>
              <div className={style.viewText}>
                <p
                  onClick={() => {
                    navigate("/profile");
                  }}
                >
                  View all
                </p>
              </div>
            </div>
          </>
        ) : (
          ""
        )}
          <TopicMastery/>

        <div className={style.recommendedText}>
          <p>
            <span>*</span>Recommended timeframes for optimum results are:
            <br />
            Completion of Modules 1, 2 and 5 within six weeks; Module 3 within
            10 weeks; Module 4 within 12 weeks; Modules 6 and 7 within four
            weeks
          </p>
        </div>
      </div>
    </div>
  );
};

export default Performance;
